import React from 'react';
import { ConfigProvider } from 'antd';
import { HelmetProvider } from 'react-helmet-async';
import { AppRouter } from './components/router/AppRouter';
import { ErrorBoundary } from './components/common/ErrorBoundary/ErrorBoundary';
import { usePWA } from './hooks/usePWA';
import { useLanguage } from './hooks/useLanguage';
import { useAutoNightMode } from './hooks/useAutoNightMode';
import { useThemeWatcher } from './hooks/useThemeWatcher';
import { useAppSelector } from './hooks/reduxHooks';
import { themeObject } from './styles/themes/themeVariables';
import deDe from 'antd/lib/locale/de_DE';
import enUS from 'antd/lib/locale/en_US';
import frFr from 'antd/lib/locale/fr_FR';
import itIt from 'antd/lib/locale/it_IT';
import GlobalStyle from './styles/GlobalStyle';
import 'typeface-montserrat';
import 'typeface-lato';

import 'antd/dist/reset.css';

const langMapper = {
  en: enUS,
  de: deDe,
  fr: frFr,
  it: itIt,
};

const App: React.FC = () => {
  const { language } = useLanguage();
  const theme = useAppSelector((state) => state.theme.theme);

  usePWA();

  useAutoNightMode();

  const themeConfig = useThemeWatcher();

  return (
    <>
      <meta name="theme-color" content={themeObject[theme as keyof typeof themeObject].primary} />
      <HelmetProvider>
        <ConfigProvider componentDisabled={false} theme={themeConfig} locale={langMapper[language || 'en']}>
          <GlobalStyle />
          {/* Last resort: only reached if the layout shell itself throws. */}
          <ErrorBoundary fullHeight>
            <AppRouter />
          </ErrorBoundary>
        </ConfigProvider>
      </HelmetProvider>
    </>
  );
};

export default App;
